import React, { useEffect, useState } from 'react';
import { Image, Modal } from 'react-bootstrap';
import { connect, useDispatch } from 'react-redux';

import LoadMoreSelector from 'components/base/LoadMoreSelector';
import { LanguageConfig } from 'config/CustomEnums';

import { createAction } from 'utils';

import CloseIcon from 'assets/images/prompt_close_icon.svg';

import './CampaignFilterableSelectModal.scss';

const mapPropsToState = (state) => ({
  campaignList: state.campaignList.allList || [],
});

const CampaignFilterableSelectModal = ({
  show = true,
  onSelect = () => {},
  onClose = () => {},
  campaignList,
  language,
}) => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(createAction('campaignList/clearData')());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [show]);

  return (
    <Modal
      show={show}
      onHide={onClose}
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
    >
      <Modal.Body
        className={`base-prompt-container customer-detail-prompt campaign-select`}
      >
        <Image
          src={CloseIcon}
          className="base-prompt-close-button customer-detail-prompt-close-button"
          onClick={onClose}
        />

        <label className="customer-detail-modal-title">Select campaign</label>

        <LoadMoreSelector
          source={campaignList}
          onSelectChange={onSelect}
          placeholder={'Search by campaign ID and name'}
          defaultFilter={{
            isExpired: false,
            isPublished: true,
            searchField: 'searchNameOrId',
            reverse: true,
          }}
          loadMoreAction={'campaignList/getCampaignList'}
          customItem={(item) => {
            if (language && language !== LanguageConfig.english) {
              const translationItem = item.translations[language];
              return `[ID: ${item.pk}] ${translationItem?.name || item.name}`;
            }
            return `[ID: ${item.pk}] ${item.name}`;
          }}
        />
      </Modal.Body>
    </Modal>
  );
};

export default connect(mapPropsToState)(CampaignFilterableSelectModal);
